import { render, staticRenderFns } from "./Securities.vue?vue&type=template&id=5950e7a0&scoped=true"
import script from "./Securities.vue?vue&type=script&lang=js"
export * from "./Securities.vue?vue&type=script&lang=js"
import style0 from "./Securities.vue?vue&type=style&index=0&id=5950e7a0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5950e7a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5950e7a0')) {
      api.createRecord('5950e7a0', component.options)
    } else {
      api.reload('5950e7a0', component.options)
    }
    module.hot.accept("./Securities.vue?vue&type=template&id=5950e7a0&scoped=true", function () {
      api.rerender('5950e7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/sailing-version/components/Securities.vue"
export default component.exports